<template>
  <div>


    <div class="modal__shindan2col">
      <div class="modal__shindan2colImg">
        <img :src=result.imgPath>
      </div>
      <div class="modal__shindan2colTxt">
        <h3 class="modal__shindan2colTxtTitle">{{result.title}}<small>にオススメなローファーは</small></h3>
        <dl>
          <dt v-html="result.productName"></dt>
          <dd><span v-html="result.text"></span></dd>
        </dl><a :class=shindanBtnClass :href=result.link target="_blank" :data-name="result.name" v-on:click="click(result.id)"><div class="shindanBtnClassInlineBlock"><div class="shindanBtnClassFlex"><span v-html="result.productBtnName"></span>はこちら</div></div></a>
      </div>
    </div>


  </div>
</template>

<script>
// import Filter from './components/Filter.vue'
// import Vue from 'vue';
// 『イベントバス』のためのインスタンス
// var bus = new Vue();

export default {
  name: 'Result',
  data () {
    return {
      // msg: 'Hello Vue Component',
    }
  },
  methods : {
    click : function(name){
      // let name = "ssssss";
      // // let name = $(this).data('name');
      let utm_campaign
      if (this.get_param('utm_campaign')) {
        utm_campaign = get_param('utm_campaign')
      } else {
        utm_campaign = "none"
      }
      // console.log("to GTM ->",name);
      // console.log(name,utm_campaign)
      ga('send', 'event', 'shoesBtn', name, utm_campaign)
    },
    get_param : function(name, url){
      if (!url) url = window.location.href;
      // console.log(url)
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      // console.log(results)
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
  },
  computed : {
    result : function(){
      var rid = this.$store.state.userSelect.resultId;
      // return rid;
      return this.$store.state.result.find(item => item.id == rid);
    },
    shindanBtnClass : function(){
      return 'btn-ga modal__shindanBtn ' + 'modal__shindanBtn--line' + this.result.productBtnLine;
    }
  },
}
</script>

<style>
</style>
